import React from 'react';

import { EditProfile } from '@/components/AccountPanel/components/EditProfile';
import { IndexIndicator } from '@/components/shared/IndexIndicator';
import { classNames } from '@/helpers/classNames';
import { useAnalyticsEvent } from '@/providers/AnalyticsProvider';
import { usePermissions } from '@/providers/PermissionsProvider';

import { OnboardingContext } from './Onboarding';
import styles from './Onboarding.module.scss';

const StepTwo = () => {
	const { setStep, step, canUpdateTeam, shouldAddService, completedStepIndices } =
		React.useContext(OnboardingContext);
	const fireSaveProfile = useAnalyticsEvent('Onboarding_Step2_Save_Profile');

	return (
		<EditProfile
			hasBack
			actionLabel="Next"
			bottomActionProps={{
				className: styles['layout'],
				contentClassName: styles['step-two'],
				topContent: (
					<IndexIndicator
						className={styles['indicator']}
						dotClassName={styles['dot']}
						total={canUpdateTeam ? 6 : 2}
						current={0}
						variant="stretched"
						onIndicatorClick={(i) => setStep(i + 2)}
						hasHover
						conditionalItems={[
							{ index: 3, visible: shouldAddService },
						]}
						disabledItems={[{ index: 5, enabled: false }]}
					hasDataItems={completedStepIndices}
					/>
				),
			}}
			onBack={() => {
				setStep(step - 1);
			}}
			onSave={() => {
				fireSaveProfile();
				setStep(step + 1);
			}}
			leadingContent={
				<div className={styles['title-header']}>
					<div className={styles['heading']}>First, about you</div>
					<div className={classNames([styles['text'], 'mt-sm'])}>
						How you'll appear in Asaph.
					</div>
				</div>
			}
		/>
	);
};

export default StepTwo;
